import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar Aba")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-21 ui-cell" }, " Título "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_8 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_9 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-21 ui-cell",
  "data-title": "Título"
}
const _hoisted_10 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center",
  "data-title": "Ações"
}
const _hoisted_11 = { class: "ui-actions" }
const _hoisted_12 = { class: "ui-action ui-move" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Cancelar")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Confirmar")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "ui-button -primary ui-mh-32 ui-full",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.adicionarAba()))
            }, _hoisted_5)
          ])
        ]),
        (_ctx.computedAbasInformativas.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhuma aba foi adicionado ainda"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.computedAbasInformativas,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedAbasInformativas) = $event)),
                  "item-key": "index",
                  handle: ".ui-move"
                }, {
                  item: _withCtx(({element,index}) => [
                    (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "ant-row ui-row"
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(element.titulo), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_tooltip, { title: "Arraste para cima ou para baixo para ordenar as abas" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_12, [
                                _createVNode(_component_icone, { nome: "ordenar-lista" })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tooltip, { title: "Editar" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ui-action",
                                onClick: ($event: any) => (_ctx.apresentarEdicaAba(index,element))
                              }, [
                                _createVNode(_component_icone, { nome: "editar" })
                              ], 8, _hoisted_13)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_tooltip, { title: "Deletar" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ui-action",
                                onClick: ($event: any) => (_ctx.removerAba(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_14)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 900,
      visible: _ctx.state.apresentarEdicao,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.apresentarEdicao) = $event)),
      title: "Aba Informativa"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "ui-button -second",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.apresentarEdicao = false))
          }, _hoisted_16),
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmarEdicaoAba()))
          }, _hoisted_18)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_a_form_item, { label: "Título" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.tituloEdicao) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.tituloEdicao]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_a_form_item, { label: "Conteúdo" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.conteudoEdicao,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.conteudoEdicao) = $event)),
                      minHeight: '500'
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}